import { CircularProgress, Stack } from "@mui/material";
import React, { Component } from "react";
import Alert from "../Alert";
import Dialog from "./Dialog";

export default class ConfirmationDialog extends Component<any> {
  static defaultProps = {
    cancelButton: "Cancel",
    acceptButton: "OK",
  };

  constructor(props: any) {
    super(props);
  }

  render() {
    const {
      title,
      theme,
      question,
      cancelButton,
      acceptButton,
      onCancel,
      onAccept,
      error,
      acceptDanger,
      isNotShowAcceptButton = false,
      loading,
    } = this.props;

    const listButton = isNotShowAcceptButton
      ? [
          {
            label: cancelButton,
            onClick: onCancel,
            disabled: loading,
          },
        ]
      : [
          {
            label: acceptButton,
            acceptDanger: acceptDanger,
            primary: true,
            onClick: onAccept,
            disabled: loading,
            icon: loading && (
              <CircularProgress
                size={20}
                {...(acceptDanger
                  ? {
                      color: "inherit",
                      style: {
                        color: "#fff",
                      },
                    }
                  : {})}
              />
            ),
          },
          {
            label: cancelButton,
            onClick: onCancel,
            disabled: loading,
          },
        ];

    return (
      <Dialog
        open={true}
        theme={theme}
        title={title}
        onClose={onCancel}
        maxWidth="sm"
        actions={listButton}
      >
        <Stack direction="column" spacing={4}>
          {error && (
            <div>
              <Alert severity="error">{error}</Alert>
            </div>
          )}

          <div className="klayo-confirmation-question-text">{question}</div>
        </Stack>
      </Dialog>
    );
  }
}
